export default {
    computed: {
       contacts() {return this.$store.getters.getCurrentContacts }
    }
}